import { PinIcon } from 'lucide-react'
import { memo } from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export interface ChatPinButtonProps {
  itemId: string

  isPinned: boolean

  onPin: (itemId: string) => void

  className?: string
}

const ChatPinButtonBase: React.FC<ChatPinButtonProps> = ({
  itemId,
  isPinned,
  onPin,
  className,
}) => {
  const handlePin = (e: React.MouseEvent): void => {
    e.stopPropagation()
    onPin(itemId)
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn(
            'chat-pin-button size-7 text-muted-foreground hover:text-foreground',
            isPinned && 'text-primary hover:text-primary',
            className
          )}
          onClick={handlePin}
        >
          <PinIcon className={cn('size-3.5', isPinned && 'fill-current')} />
          <span className="sr-only">{isPinned ? 'Unpin message' : 'Pin message'}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">{isPinned ? 'Unpin' : 'Pin'}</TooltipContent>
    </Tooltip>
  )
}

export const ChatPinButton = memo(ChatPinButtonBase)

ChatPinButton.displayName = 'ChatPinButton'
